import type { OptionType } from '@innovamat/glimmer-components';
import { COURSE_GRADE_MAPPING } from './constants';

export type DocumentType = 'pacing-guide' | 'personalized-practice' | '';
export type DownloadType = 'single' | 'separate';
export type Language = 'en' | 'es';

export type FormState = {
  selectedGrade: string;
  documentType: DocumentType;
  downloadType: DownloadType;
  hideStandards: boolean;
  language: Language;
};

export const gradeOptions: OptionType[] = Object.entries(
  COURSE_GRADE_MAPPING
).map(([id, grade]) => ({
  value: id,
  label: grade,
}));

export const documentTypeOptions: OptionType[] = [
  { value: 'pacing-guide', label: 'Pacing Guide' },
  { value: 'personalized-practice', label: 'Personalized Practice' },
];

export const downloadTypeOptions: OptionType[] = [
  { value: 'separate', label: 'Separate PDFs (By stretch/module)' },
  {
    value: 'single',
    label: 'Single PDF (All content) - Redirects to print preview screen',
  },
];

export const standardsOptions: OptionType[] = [
  { value: 'false', label: 'With Standards' },
  { value: 'true', label: 'Without Standards' },
];

export const languageOptions: OptionType[] = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
];
